import { createLucideIcon } from "lucide-react";

export const Tick = createLucideIcon(
    "Tick",
    [
        [
            "path",
            {
                d: "M5 14L8.5 17.5L19 6.5",
                key: "d5q9uk",
            },
        ],
    ],
);
